<template>
    <div class="hotel-info-room-offers-header">
        <v-card-title v-if="filteredOffer" class="text-h6 font-weight-light align-baseline">
            {{ $t('available_room_list') }}
            <span
                v-if="!isAlwaysVisibleFilters"
                class="ml-4 text-body-2 text-primary cursor-pointer offers-filter-select-btn"
                @click="expanded = !expanded"
            >
                {{ $t('filters') }}
                <v-icon color="primary" size="small">
                    {{ expanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                </v-icon>
            </span>
        </v-card-title>
        <v-card-title v-else-if="!isSearchActive && loaded" class="text-h6 font-weight-light">
            {{ $t('no_available_rooms') }}
        </v-card-title>
        <v-expand-transition v-model="expanded">
            <v-row v-if="expanded || isAlwaysVisibleFilters" no-gutters class="mx-4">
                <v-col cols="12" md="9" class="hotel-info-room-offers-header__filters mb-6 mb-md-0">
                    <room-filters :filter-values="filtersValues" @change="setFilters" />
                </v-col>
                <v-col cols="12" md="3" class="hotel-info-room-offers-header__group">
                    <group-offers-select
                        :items="['none', 'name', 'mealTypeStandardCode']"
                        :product-store="productStore"
                        token-base="roomGroupBy"
                    />
                </v-col>
            </v-row>
        </v-expand-transition>
    </div>
</template>

<script lang="ts">
    import {Vue, Component, Prop, Emit} from 'vue-facing-decorator'
    import RoomFilters from '~src/components/search/filters/RoomFilters.vue'
    import GroupOffersSelect from '~src/components/search/GroupOffersSelect.vue'

    @Component({
        components: {
            RoomFilters,
            GroupOffersSelect,
        },
    })
    export class HotelInfoRoomOffersHeader extends Vue {
        @Prop() filteredOffer
        @Prop({default: false, type: Boolean}) isSearchActive
        @Prop({default: false, type: Boolean}) loaded

        expanded = false

        @Emit()
        setFilters(values) {
            return values
        }

        get productStore() {
            return hotelsStore
        }

        get filtersValues() {
            return hotelsStore.singleHotelSearchResponse.filters
        }

        get isAlwaysVisibleFilters() {
            return false
        }
    }

    export default HotelInfoRoomOffersHeader
</script>
